import { Outlet } from '@tanstack/react-router';
import { DEFAULT_USER_SETTINGS } from '@citylytics/domain/user-settings/constants';
import { ReducedMotionProvider } from '@citylytics/ui-web/components/reduced-motion-provider';
import { Toaster } from '@citylytics/ui-web/components/ui/toast';
import { useSavedLanguage } from '@citylytics/web-session/session/hooks';
import { useAuthStore } from '~/lib/session/session.singleton';

/**
 * Everything under the router: toasts around the current page, in the account's language and
 * motion. client-web has no motion control of its own yet, so signed out it follows the device
 * and signed in it follows the choice saved on the account (from admin-web's settings).
 */
export function RootLayout() {
  const reduceMotion = useAuthStore(
    (state) => state.user?.settings.reduceMotion ?? DEFAULT_USER_SETTINGS.reduceMotion,
  );

  useSavedLanguage(useAuthStore);

  return (
    <ReducedMotionProvider preference={reduceMotion}>
      <Toaster>
        <Outlet />
      </Toaster>
    </ReducedMotionProvider>
  );
}
